module.exports = __webpack_public_path__ + "static/media/logo_daiwa.31ec05da.png";